/* Translated by dacampsss */

export default {
  translation: {
    common: {
      accept: 'Aceitar',
      alreadyUser: 'Já está registrado?',
      and: 'e',
      backToLogin: 'Voltar à página de login',
      coreNotFound: 'Falha em obter configurações base',
      createAccount: 'Criar uma conta',
      createYourAccount: 'Crie sua conta',
      emailOrUsername: 'Email ou nome de usuário',
      invalidUsernameOrPassword: 'Nome de usuário ou senha incorretos',
      localRegistrationDisabled: 'O registro de usuários locais foi desabilitado pela administração',
      login: 'Login',
      logInToBoards: 'Entrar',
      continueWith: 'Continuar com o {{provider}}',
      newToBoards: 'Novo no 4ga Boards?',
      noInternetConnection: 'Sem conexão com a internet',
      pageNotFound_title: 'Página Não Encontrada',
      password: 'Senha',
      policyNotAccepted: 'Por favor, aceite os Termos de Serviço e Política de Privacidade',
      privacyPolicy: 'Política de Privacidade',
      register: 'Registrar-se',
      registerWithGoogle: 'Registrar-se com Google',
      registrationDisabled: 'O registro de usuários foi desabilitado pela administração',
      serverConnectionFailed: 'A conexão com o servidor falhou',
      ssoRegistrationDisabled: 'O registro de usuários por SSO foi desabilitado pela administração',
      termsOfService: 'Termos de Serviço',
      togglePasswordVisibility: 'Alternar visibilidade da senha',
      unknownError: 'Erro desconhecido, tente novamente mais tarde',
    },

    action: {
      logIn: 'Entrar',
    },
  },
};
